"use client";

import "@getpara/react-sdk/styles.css";
import { ParaProvider } from "./context/ParaProvider";
import { QueryProvider } from "./context/QueryProvider";
import { TooltipProvider } from "@/components/ui/tooltip";

export function Providers({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <QueryProvider>
      <ParaProvider>
        <TooltipProvider>{children}</TooltipProvider>
      </ParaProvider>
    </QueryProvider>
  );
}
